module.exports = __webpack_public_path__ + "static/media/yogyakarta.8c436213.png";